import { PROPERTIES_SELECTION_FABRICS, TWO_EM_DASH } from '@/common/constants';
import { getUniqueStylesWithPropertyName } from '@/common/utils';
import PpSelect from '@/components/Selectors/Select';
import { useAppCommon, useProperties } from '@/hooks';
import { useText } from '@/views/CreateBook/composables';

export default {
  components: {
    PpSelect
  },
  props: {
    selectedFont: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isTextProperties: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFontWhenSelection: null,
      componentKey: true
    };
  },
  setup() {
    const { getFonts } = useText();
    const { currentSelectionTextStyle } = useAppCommon();
    const { getProperty } = useProperties();
    return { getFonts, currentSelectionTextStyle, getProperty };
  },
  computed: {
    fontFamily() {
      // mention here to re-computed property if any chanfe
      this.componentKey = !!this.componentKey;
      return this.updateFont();
    }
  },
  methods: {
    /**
     * Emit to back value to parent
     * @param {Object} data new font family of text box
     */
    onChange(data) {
      if (data.name !== TWO_EM_DASH) {
        this.forceRenderComponent();
      }
      this.$emit('change', {
        fontFamily: data.name
      });
    },
    forceRenderComponent() {
      this.componentKey = !this.componentKey;
    },
    updateFont() {
      const listFont = this.getFonts();
      if (!this.isTextProperties) {
        return listFont;
      }
      const listStyle = getUniqueStylesWithPropertyName(
        PROPERTIES_SELECTION_FABRICS.FONT_FAMILY,
        this.currentSelectionTextStyle
      );

      if (!listStyle.length) {
        this.selectedFontWhenSelection = null;
        return listFont;
      }
      const canvas = window.printCanvas || window.digitalCanvas;
      if (listStyle.length === 1) {
        if (
          canvas.getActiveObject().type === 'group' &&
          this.getProperty(PROPERTIES_SELECTION_FABRICS.FONT_FAMILY) !==
            listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_FAMILY]
        ) {
          listFont.unshift({
            name: TWO_EM_DASH,
            value: TWO_EM_DASH
          });
          this.selectedFontWhenSelection = listFont[0];
          return listFont;
        }
        this.selectedFontWhenSelection = listFont.find(
          item =>
            item.name === listStyle[0][PROPERTIES_SELECTION_FABRICS.FONT_FAMILY]
        );
        return listFont;
      } else {
        listFont.unshift({
          name: TWO_EM_DASH,
          value: TWO_EM_DASH
        });
        this.selectedFontWhenSelection = listFont[0];
        return listFont;
      }
    }
  }
};
